(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["browse-by-set"] && !Shopify.designMode) return;
  try {
    // Fill set-entry counts from the collection's product tags. Server-rendered
  // counts (Search & Discovery) win; this only fills empty slots. One
  // products.json request per 250 products, capped at 1000. Empty sets hide.
  document.querySelectorAll('.browse-by-set[data-collection-url]').forEach((root) => {
    const slots = [...root.querySelectorAll('[data-count-slot][data-count-tag]')].filter((s) => !s.textContent.trim());
    if (!slots.length) return;
    const total = parseInt(root.dataset.collectionCount, 10) || 0;
    const pages = Math.min(Math.ceil(total / 250), 4);
    const requests = [];
    for (let page = 1; page <= pages; page += 1) {
      requests.push(
        fetch(`${root.dataset.collectionUrl}/products.json?limit=250&page=${page}`)
          .then((r) => (r.ok ? r.json().then((d) => ({ products: d.products, ok: true })) : { products: [], ok: false }))
          .catch(() => ({ products: [], ok: false }))
      );
    }
    Promise.all(requests).then((results) => {
      const counts = {};
      let gotData = false;
      let allOk = true;
      results.forEach(({ products, ok }) => {
        if (!ok) allOk = false;
        if (products && products.length) gotData = true;
        (products || []).forEach((p) => {
          (p.tags || []).forEach((t) => {
            const key = t.toLowerCase().trim();
            counts[key] = (counts[key] || 0) + 1;
          });
        });
      });
      // No data at all (transient failure / CORS): leave entries as
      // server-rendered rather than hiding the whole nav.
      if (!gotData) return;
      slots.forEach((slot) => {
        const count = counts[slot.dataset.countTag.toLowerCase().trim()] || 0;
        const link = slot.closest('a');
        // Only hide a zero set when the dataset is COMPLETE — a partial-page
        // failure must not hide sets that live on the pages that didn't load.
        if (count === 0 && allOk && link && !link.classList.contains('is-active')) {
          const row = slot.closest('li');
          if (row) row.hidden = true;
          return;
        }
        if (count > 0) slot.textContent = ` (${count})`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class QuantityStepper extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="number"]');
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      const trigger = event.target.closest('[data-step]');
      if (!trigger || !this.input) return;

      const min = parseInt(this.input.min, 10) || 1;
      let value = parseInt(this.input.value, 10);
      if (Number.isNaN(value)) value = min;

      value = trigger.dataset.step === 'up' ? value + 1 : Math.max(min, value - 1);

      this.input.value = value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('quantity-stepper')) {
    customElements.define('quantity-stepper', QuantityStepper);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["products-grid"] && !Shopify.designMode) return;
  try {
    class ProductsGrid extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.products-grid__track');
      this.prev = this.querySelector('.products-grid__arrow--prev');
      this.next = this.querySelector('.products-grid__arrow--next');
      if (!this.track || !this.prev || !this.next) return;
      this.prev.addEventListener('click', () => this.page(-1));
      this.next.addEventListener('click', () => this.page(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.page(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.page(1); }
      });
      this.update();
    }
    page(dir) {
      this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      this.prev.disabled = this.track.scrollLeft <= 0;
      this.next.disabled = this.track.scrollLeft >= max;
    }
  }
  if (!customElements.get('products-grid')) customElements.define('products-grid', ProductsGrid);
  } catch(e) { console.error(e); }
})();

})();
